// O CSS do MapLibre vem primeiro de propósito: com a mesma especificidade,
// a última regra vence, e o estilo do projeto precisa ser o último a falar.
// Foi por isso que os controles do mapa ficaram com 29 px apesar da regra.
import 'maplibre-gl/dist/maplibre-gl.css';
import '../estilo.css';
import { CONFIG } from './config.js';
import { criaMapa } from './mapa.js';
import { criaCartao } from './cartao.js';
import { criaPainel } from './painel.js';
import { criaLista } from './lista.js';
import { criaTelemetria } from './eventos.js';
import {
  aplicaFiltros, paraUrl, urlDoEstado, daUrl, opcoesDe, contaAtivos, contaVendidos,
  criaPainelFiltros, ESTADO_VAZIO,
} from './filtros.js';

const $ = (id) => document.getElementById(id);
const elContador = $('contador');

/** Falha visível vale mais que um mapa cinza silencioso. */
function falha(oQue, erro) {
  console.error(oQue, erro);
  elContador.textContent = 'não foi possível carregar o mapa';
  elContador.style.color = '#b91c1c';
}
window.addEventListener('error', (e) => falha('erro na página', e.error ?? e.message));
window.addEventListener('unhandledrejection', (e) => falha('promessa rejeitada', e.reason));

const mapa = criaMapa($('mapa'));
mapa.mapa.on('error', (e) => falha('erro do mapa', e.error ?? e));

const cartao = criaCartao($('cartao'));
const painel = criaPainel($('painel'));
const lista = criaLista($('resultados'), (slug) => painel.abre(slug));
const telemetria = criaTelemetria();

// Delegação num só lugar: pega os CTAs do cartão, do painel e da lista.
document.addEventListener('click', (e) => {
  const alvo = e.target.closest('[data-evento]');
  if (alvo) telemetria.registra(alvo.dataset.evento, { id: Number(alvo.dataset.id) });
});

// Sem hover em toque: o cartão flutuante é desligado e o painel deslizante
// passa a ser o único caminho.
const ehToque = window.matchMedia('(hover: none), (max-width: 760px)').matches;
const ehEstreito = window.matchMedia('(max-width: 760px)').matches;

// O texto longo do campo de busca não cabe na primeira linha do celular e
// empurraria o cabeçalho para uma terceira linha.
if (ehEstreito) $('busca').placeholder = 'Buscar imóvel ou bairro';
if (!ehToque) {
  mapa.aoPassarMouse((props, ponto) => {
    if (props) {
      cartao.mostra(props, ponto);
      telemetria.registra('marcador_hover', { id: props.id, slug: props.slug });
    } else cartao.esconde();
  });
}
mapa.aoClicar((props) => {
  telemetria.registra('marcador_clique', { id: props.id, slug: props.slug });
  painel.abre(props.slug);
});

$('legenda').innerHTML = Object.entries(CONFIG.rotuloTipo)
  .map(([slug, rotulo]) =>
    `<div class="legenda-item"><span class="legenda-cor" style="background:${CONFIG.cor[slug]}"></span>${rotulo}</div>`)
  .join('');

// ---- dados ----
const dados = await fetch(CONFIG.dados).then((r) => {
  if (!r.ok) throw new Error(`geojson HTTP ${r.status}`);
  return r.json();
});

let estado = daUrl(location.search);
const opcoes = opcoesDe(dados.features);
const totalVendidos = contaVendidos(dados.features);
const elFiltros = $('filtros');
const elFundoFiltros = $('fundo-filtros');
const painelFiltros = criaPainelFiltros($('filtros-corpo'), opcoes, (novo) => {
  // Sem redesenhar a cada clique: o estado visual dos chips vem do CSS
  // `:has(input:checked)`, e redesenhar destruiria o elemento que acabou de
  // receber o foco, jogando a navegação por teclado de volta ao começo.
  atualiza(novo);
});

function atualiza(novo) {
  estado = novo;
  painelFiltros.defineBusca(estado.busca);
  const visiveis = aplicaFiltros(dados.features, estado);
  mapa.defineDados({ type: 'FeatureCollection', features: visiveis });
  lista.desenha(visiveis);
  const escondidos = estado.mostrarVendidos ? 0 : totalVendidos;
  elContador.textContent =
    `${visiveis.length} ${visiveis.length === 1 ? 'empreendimento' : 'empreendimentos'}`
    + (escondidos ? ` · ${escondidos} vendidos ocultos` : '');
  $('filtros-contagem').textContent =
    `${visiveis.length} ${visiveis.length === 1 ? 'imóvel' : 'imóveis'}`;
  const ativos = contaAtivos(estado);
  const selo = $('filtros-ativos');
  selo.hidden = ativos === 0;
  selo.textContent = String(ativos);
  history.replaceState(null, '', urlDoEstado(estado, location.pathname, location.hash));
  telemetria.registra('filtro_aplicado', { filtros: paraUrl(estado), resultados: visiveis.length });
  return visiveis;
}

painelFiltros.desenha(estado);
$('busca').value = estado.busca;

function alternaFiltros(abrir) {
  elFiltros.hidden = !abrir;
  elFundoFiltros.hidden = !abrir;
  $('abrir-filtros').setAttribute('aria-expanded', String(abrir));
  // Trava a rolagem do fundo enquanto o painel de filtros cobre a tela.
  document.body.style.overflow = abrir ? 'hidden' : '';
  if (abrir) {
    $('filtros-corpo').scrollTop = 0;
    $('fechar-filtros').focus();
  } else {
    $('abrir-filtros').focus();
  }
}
$('abrir-filtros').addEventListener('click', () => alternaFiltros(elFiltros.hidden));
$('fechar-filtros').addEventListener('click', () => alternaFiltros(false));
$('aplicar-filtros').addEventListener('click', () => alternaFiltros(false));
elFundoFiltros.addEventListener('click', () => alternaFiltros(false));
$('limpar-filtros').addEventListener('click', () => {
  atualiza({ ...ESTADO_VAZIO, busca: estado.busca });
  painelFiltros.desenha(estado);
});
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape' && !elFiltros.hidden) alternaFiltros(false);
});

let timerBusca;
$('busca').addEventListener('input', (e) => {
  clearTimeout(timerBusca);
  const v = e.target.value;
  timerBusca = setTimeout(() => atualiza({ ...estado, busca: v }), 200);
});

// Especificação §8.1: o enquadramento inicial é a Região Metropolitana, com um
// botão para o Ceará inteiro — há imóveis em Sobral, Juazeiro, Barbalha e Icó
// que ficariam invisíveis sem isso.
$('ver-ceara').addEventListener('click', () => mapa.enquadraCeara());

// ---- alternador mapa / lista ----
const btMapa = $('ver-mapa');
const btLista = $('ver-lista');
function alterna(paraLista) {
  $('mapa').hidden = paraLista;
  $('resultados').hidden = !paraLista;
  btMapa.setAttribute('aria-pressed', String(!paraLista));
  btLista.setAttribute('aria-pressed', String(paraLista));
  if (!paraLista) mapa.redimensiona();
}
btMapa.addEventListener('click', () => alterna(false));
btLista.addEventListener('click', () => alterna(true));

window.addEventListener('resize', () => mapa.redimensiona());

// Sem await no mapa: a contagem e a lista não podem ficar reféns de o mapa
// terminar de pintar. `defineDados` já espera o mapa internamente, então o
// GeoJSON chega lá assim que ele estiver pronto.
atualiza(estado);

telemetria.registra('mapa_aberto', { total: dados.features.length });

// Link profundo: #imovel=<slug> abre o imóvel direto — é o que o SDR manda
// para o lead quando quer falar de um empreendimento específico.
const alvo = new URLSearchParams(location.hash.slice(1)).get('imovel');
if (alvo) {
  const f = dados.features.find((x) => x.properties.slug === alvo);
  if (f) {
    mapa.voaPara(f.geometry.coordinates[0], f.geometry.coordinates[1], 16);
    painel.abre(alvo);
  }
}
